// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ku-0";
export var discountCodeInput = "_ku-1";